'use strict';

var jsxRuntime = require('react/jsx-runtime');
var material = require('@mui/material');

const FieldErrors = ({ errors = [] })=>{
    if (!Array.isArray(errors)) {
        errors = [
            errors
        ];
    }
    return /*#__PURE__*/ jsxRuntime.jsx(material.Collapse, {
        in: !!errors.length,
        unmountOnExit: true,
        children: /*#__PURE__*/ jsxRuntime.jsx(material.List, {
            component: "ul",
            disablePadding: true,
            children: errors.map((v, i)=>/*#__PURE__*/ jsxRuntime.jsx(material.ListItem, {
                    disableGutters: true,
                    children: /*#__PURE__*/ jsxRuntime.jsx(material.ListItemText, {
                        children: v.message
                    })
                }, i))
        })
    });
};

module.exports = FieldErrors;
